import React, { useState,useEffect,useCallback,useRef } from "react";
import { useParams,useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getTemplateDetail, submitSingle, getSingleDetail, updateSingle, deleteSingle} from "../../../utils/teamShowcaseApi";

const ContentTab = ({ isTemplateId,setTemplateId,updateTeamShowcaseTabData,teamShowcaseTabData,setRefreshWidgetList }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const dropdownRefs = useRef([]);
    const [apiProfileSociaMediaIcons, setApiProfileSociaMediaIcons] = useState([]);
    const [isSubmitSingle, setIsSubmitSingle] = useState(false); 
    const location = useLocation();
    const isEditPage = location.pathname.startsWith("/customer/edit/team-showcase/");
    const { uuid } = useParams();
    const templateId = isEditPage && uuid ? uuid : isTemplateId || "";
    const [apiSingle, setApiSingle] = useState(null);
    const [singleId, setSingleId] = useState(null);

    //details
    const [isShowHeader, setIsShowHeader] = useState(Number(teamShowcaseTabData.is_show_header));
    const [headerTitle, setHeaderTitle] = useState(teamShowcaseTabData.header_title);
    const [headerCaption, setHeaderCaption] = useState(teamShowcaseTabData.header_caption);
    const [isCallToAction, setIsCallToAction] = useState(Number(teamShowcaseTabData.is_call_to_action));
    const [callToActionTitle, setCallToActionTitle] = useState(teamShowcaseTabData.call_to_action_title);
    const [callToActionButtonText, setCallToActionButtonText] = useState(teamShowcaseTabData.call_to_action_button_text);
    const [callToActionButtonLink, setCallToActionButtonLink] = useState(teamShowcaseTabData.call_to_action_button_link);

    //Wrap fetchTemplateDetails in useCallback to prevent re-creation on every render
    const fetchTemplateDetails = useCallback(async () => {
        if (!templateId) return;

        setIsLoading(true);
        try {
            const templateResult = await getTemplateDetail(templateId);
            if (templateResult?.status === true && Array.isArray(templateResult?.data?.data_list)) {
                if (templateResult?.status === true && templateResult?.data?.data_list) {
                    setApiProfileSociaMediaIcons(templateResult.data.data_list);
                } else {
                    setApiProfileSociaMediaIcons([]);
                }
            } else {
                setApiProfileSociaMediaIcons([]);
            }
        } catch (error) {
            //console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [templateId]);

    // Fix useEffect by including fetchTemplateDetails
    useEffect(() => {
        fetchTemplateDetails();
    }, [fetchTemplateDetails]);

    // Toggle dropdown visibility
    const toggleDropdown = (index) => {
        setOpenDropdown((prev) => (prev === index ? null : index));
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                openDropdown !== null &&
                dropdownRefs.current[openDropdown] &&
                !dropdownRefs.current[openDropdown].contains(event.target) &&
                !event.target.closest(".inner-dropdown-menu")
            ) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdown]);

    //Submit Single Handler
    const handleSubmitSingle = async (e) => {
        e.preventDefault();

        try {
            setIsSubmitSingle(true);
            setOpenDropdown(null);

            // Create FormData object
            const formData = new FormData();
            formData.append("template_id", templateId);
            formData.append("name", e.target.name.value || '');
            formData.append("position", e.target.position.value || '');
            formData.append("description", e.target.description.value || '');
            formData.append("image", e.target.image.files[0] || '');
            formData.append("email", e.target.email.value || '');
            formData.append("phone", e.target.phone.value || '');
            formData.append("location", e.target.location.value || '');
            formData.append("website", e.target.website.value || '');
            formData.append("quote", e.target.quote.value || '');
            formData.append("external_link", e.target.external_link.value || '');

            //Api Call
            const response = await submitSingle(formData);
            
            if (response.status === true) { 
                toast.success(response.message);
                
                //Call templat details
                await fetchTemplateDetails();
                setActiveSettingElementsTab("main");
                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(response.message);
            } 
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitSingle(false);
        }
    };

    // Handle Edit Click 
    const handleEditSingle = (data) => {
        setOpenDropdown(null);
        setSingleId(data.id);
        setActiveSettingElementsTab("edit_single");
        fetchSingleDetails(data.id);
    };

    // Handle Delete Click
    const handleDeleteSingle = async (data) => {
        setOpenDropdown(null);

        try {
            // Prepare the payload
            const payload = {
                single_id: data.id,
            };

            // API Call
            const api_response = await deleteSingle(payload);
            // Check API Response
            if (api_response.status === true) {
                toast.success(api_response.message);

                // Refresh testimonials
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error(`${error.message}`);
        }
    };

    // Wrap fetchSingleDetails in useCallback to prevent re-creation on every render
    const fetchSingleDetails = useCallback(async (singleId) => {
        if (!singleId) return;

        setIsLoading(true); 
        try {
            const templateResult = await getSingleDetail(singleId); 
            if (templateResult?.status === true && templateResult?.data) {
                setApiSingle(templateResult.data);
            } else { 
                setApiSingle(null);
            }
        } catch (error) {
            //console.error("Error fetching:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Also include fetchTemplateDetails in this useEffect
    useEffect(() => {
        if (isEditPage && uuid && !apiSingle) {
            fetchSingleDetails(uuid);
        }
    }, [isEditPage, uuid, apiSingle, fetchSingleDetails]);

    //Update Single Handler
    const handleUpdateSingle = async (e) => {
        e.preventDefault();

        try {
            setIsSubmitSingle(true);
            setOpenDropdown(null);
            // Create FormData object
            const formData = new FormData();
            formData.append("id", singleId);
            formData.append("name", e.target.name?.value || '');
            formData.append("position", e.target.position?.value || '');
            formData.append("description", apiSingle.description || '');
            formData.append("image", e.target.image?.files[0] || '');
            formData.append("email", e.target.email?.value || '');
            formData.append("phone", e.target.phone?.value || '');
            formData.append("location", e.target.location?.value || '');
            formData.append("website", e.target.website?.value || '');
            formData.append("quote", e.target.quote?.value || '');
            formData.append("external_link", e.target.external_link?.value || '');

            //Api Call
            const response = await updateSingle(formData);

            if (response.status) {
                toast.success(response.message);

                //Refresh Logo Showcase
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);

                // Switch back to the main view
                setActiveSettingElementsTab("main");
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitSingle(false);
        }
    }; 

    //Handlers Show Header Change
    const handleShowHeaderChange = (e) => {
        const checked = e.target.checked;
        setIsShowHeader(checked);
        updateTeamShowcaseTabData("is_show_header", checked); 
    };

    //Handlers Header Title Change
    const handleHeaderTitleChange = (e) => {
        const value = e.target.value;
        setHeaderTitle(value);
        updateTeamShowcaseTabData("header_title", value); 
    };

    //Handlers Show Header Caption Change
    const handleHeaderCaptionChange = (e) => {
        const value = e.target.value;
        setHeaderCaption(value);
        updateTeamShowcaseTabData("header_caption", value); 
    };

    //Handlers Show Call To Action Change
    const handleShowCallToActionChange = (e) => {
        const checked = e.target.checked;
        setIsCallToAction(checked);
        updateTeamShowcaseTabData("is_call_to_action", checked); 
    };

    //Handlers Call To Action Title Change
    const handleCallToActionTitleChange = (e) => {
        const value = e.target.value;
        setCallToActionTitle(value);
        updateTeamShowcaseTabData("call_to_action_title", value); 
    };

    //Handlers Call To Action Button Title Change
    const handleCallToActionButtonTitleChange = (e) => {
        const value = e.target.value;
        setCallToActionButtonText(value);
        updateTeamShowcaseTabData("call_to_action_button_text", value); 
    };

    //Handlers Call To Action Title Change
    const handleCallToActionButtonLinkChange = (e) => {
        const value = e.target.value;
        setCallToActionButtonLink(value);
        updateTeamShowcaseTabData("call_to_action_button_link", value); 
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Team Members</span>
                    <div className="side-baar-box-header ">
                        <div className="testimonal-side-baar-list">
                            {isLoading ? (
                                <div className="inner-loader-container">
                                    <div className="inner-spinner"></div>
                                    <p>Loading, please wait...</p>
                                </div>
                            ) : apiProfileSociaMediaIcons?.length > 0 ? (
                                <ul className="">
                                    {apiProfileSociaMediaIcons.map((data, index) => (
                                        <li key={index} className="testimonial-item">
                                            <button type="button" className="testimonial-item-button" onClick={() => handleEditSingle(data)}>
                                                <div className="list-image-testimonal">
                                                    <img src={data.image } alt={data.image_name} />
                                                </div>
                                                <div className="list-text-testimonal">  
                                                    <p>{data.name}</p>
                                                </div>
                                            </button>
                                            <div className="list-button-testimonal" ref={(el) => (dropdownRefs.current[index] = el)}>
                                                <button onClick={() => toggleDropdown(index)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M3.864 8.333a1.363 1.363 0 1 1 0 2.726 1.363 1.363 0 0 1 0-2.726Zm6.136 0a1.363 1.363 0 1 1 .001 2.726A1.363 1.363 0 0 1 10 8.333Zm6.136 0a1.363 1.363 0 1 1 .001 2.726 1.363 1.363 0 0 1 0-2.726Z"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                            {openDropdown === index && (
                                                <div className="inner-dropdown-menu">
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleEditSingle(data)}>Edit</button>
                                                    </div>
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleDeleteSingle(data)}> Delete</button>
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <></>
                            )}
                        </div>
                        <div className="add-testimonal-button">
                            <button onClick={() => setActiveSettingElementsTab("add_single")}>+ Add Member</button>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("widget_title")}>Widget Title<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("call_to_action")}>Call to Action<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "widget_title" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Widget Title</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                               <span>Widget Title</span>
                                <div className="form-group">
                                    <input id="open_is_show_header" className="chkbx-toggle" type="checkbox" checked={isShowHeader} onChange={handleShowHeaderChange} />
                                    <label for="open_is_show_header"></label>
                                </div>
                            </div>
                            {Number(teamShowcaseTabData.is_show_header) === 1 && (
                            <>
                                <div className="box-header-row bubble-text">
                                    <label className="mb-1"> Title</label>
                                    <input value={headerTitle} onChange={handleHeaderTitleChange} placeholder="" type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label className="mb-1"> Caption</label>
                                    <textarea className="w-100" value={headerCaption} onChange={handleHeaderCaptionChange} placeholder="" defaultValue=""></textarea>
                                </div>
                            </>
                            )}
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "call_to_action" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Call to Action</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                               <span>Show Call to Action</span>
                                <div className="form-group">
                                    <input id="open_is_show_call_to_action" className="chkbx-toggle" type="checkbox" checked={isCallToAction} onChange={handleShowCallToActionChange} />
                                    <label for="open_is_show_call_to_action"></label>
                                </div>
                            </div>
                            {Number(teamShowcaseTabData.is_call_to_action) === 1 && (
                            <>
                                <div className="box-header-row bubble-text">
                                    <label className="mb-1"> Title</label>
                                    <input value={callToActionTitle} onChange={handleCallToActionTitleChange} placeholder="" type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label className="mb-1"> Button Text</label>
                                    <input value={callToActionButtonText} onChange={handleCallToActionButtonTitleChange} placeholder="" type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label className="mb-1"> Button Link</label>
                                    <input value={callToActionButtonLink} onChange={handleCallToActionButtonLinkChange} placeholder="" type="text" />
                                </div>
                            </>
                            )}
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "add_single" && (
                <div className="inner-box-layout">
                    <form onSubmit={handleSubmitSingle}>
                        <span>
                            <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                                <i className="fa fa-angle-left" aria-hidden="true"></i>Cancel
                            </button>
                            Add Member
                        </span>

                        <div className="side-baar-box-header">
                            <div className="box-header-row bubble-text">
                                <label>Name</label>
                                <input name="name" placeholder="Name..." type="text" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <label>Position</label>
                                <input name="position" placeholder="Position..." type="text" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <label> Description</label>
                                <textarea
                                    className="w-100"
                                    name="description"
                                ></textarea>
                            </div>
                            <div className="box-header-row">
                                <span>Photo</span>
                                <input type="file" name="image" accept="image/*" />
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <p>Contact Info</p>
                            <div className="box-header-row bubble-text">
                                <label>Email</label>
                                <input name="email" placeholder="Email..." type="text" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <label>Phone</label>
                                <input name="phone" placeholder="Phone..." type="text" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <label>Location</label>
                                <input name="location" placeholder="Location..." type="text" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <label>Website</label>
                                <input name="website" placeholder="Website..." type="text" />
                            </div>
                        </div>

                        <div className="side-baar-box-header">
                            <p>Additional Info</p>
                            <div className="box-header-row bubble-text">
                                <label>Quote</label>
                                <input name="quote" placeholder="Quote..." type="text" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <label>External Link</label>
                                <input name="external_link" placeholder="External Link..." type="text" />
                            </div>
                            <div className="customize-button mb-2"> 
                                <button type="submit" className="float-none text-black bg-white" disabled={isSubmitSingle}>
                                    {isSubmitSingle ? "Submiting..." : "Submit"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            )}

            {activeSettingElementsTab === "edit_single" && (
                <div className="inner-box-layout">
                    {isLoading ? (
                        <div className="inner-loader-container">
                            <div className="inner-spinner"></div>
                            <p>Loading, please wait...</p>
                        </div>
                    ) : apiSingle ? (
                        <>
                        <form onSubmit={handleUpdateSingle}>
                            <span>
                                <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i>Cancel
                                </button>
                                Edit Icon
                            </span>

                            <div className="side-baar-box-header">
                                <div className="box-header-row bubble-text">
                                    <label>Name</label>
                                    <input name="name" value={apiSingle.name || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, name: e.target.value })} placeholder="Name..." type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label>Position</label>
                                    <input name="position" value={apiSingle.position || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, position: e.target.value })} placeholder="Position..." type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label> Description</label>
                                    <textarea
                                        className="w-100"
                                        value={apiSingle.description || ""}
                                        onChange={(e) =>
                                            setApiSingle({ ...apiSingle, description: e.target.value })
                                        }
                                    />
                                </div>
                                <div className="box-header-row">
                                    <span>Photo</span>
                                   <input type="file" name="image" accept="image/*" />
                                    {apiSingle.image && (
                                        <img src={apiSingle.image} alt={apiSingle.image_name} width="50" height="50" />
                                    )}
                                </div>
                            </div>

                            <div className="side-baar-box-header">
                                <p>Contact Info</p>
                                <div className="box-header-row bubble-text">
                                    <label>Email</label>
                                    <input name="email" value={apiSingle.email || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, email: e.target.value })} placeholder="Email..." type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label>Phone</label>
                                    <input name="phone" value={apiSingle.phone || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, phone: e.target.value })} placeholder="Phone..." type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label>Location</label>
                                    <input name="location" value={apiSingle.location || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, location: e.target.value })} placeholder="Location..." type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label>Website</label>
                                    <input name="website" value={apiSingle.website || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, website: e.target.value })} placeholder="Website..." type="text" />
                                </div>
                            </div>

                            <div className="side-baar-box-header">
                                <p>Additional Info</p>
                                <div className="box-header-row bubble-text">
                                    <label>Quote</label>
                                    <input name="quote" value={apiSingle.quote || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, quote: e.target.value })} placeholder="Quote..." type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label>External Link</label>
                                    <input name="external_link" value={apiSingle.external_link || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, external_link: e.target.value })} placeholder="External Link..." type="text" />
                                </div>
                                <div className="customize-button mb-2"> 
                                    <button type="submit" className="float-none text-black bg-white" disabled={isSubmitSingle}>
                                        {isSubmitSingle ? "Updating..." : "Update"}
                                    </button>
                                 </div>
                            </div>
                        </form>
                        </>
                    ) : (
                        <p>No single details. Please try again.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default ContentTab;